/**
 * Ett påskägg. Batman är ingen anställd — han finns bara i den här filen, har
 * ingen rad i databasen och kan varken stämpla in eller ut. Rör inget här om du
 * letar efter riktig funktionalitet.
 */

import { useEffect } from "react";

import signal from "@/assets/batman/batman-signal.png";
import portrait from "@/assets/batman/batman-portratt.png";
import { playBatSting } from "@/lib/batSound";

/** Brickan i panelen. Ser ut som en anställd, är det inte. */
export function BatSignalTile({ onSummon }: { onSummon: () => void }) {
  return (
    <button
      onClick={onSummon}
      aria-label="Batman"
      className="press flex flex-col items-center rounded-3xl bg-[#12100b] p-5 text-center shadow-tile ring-2 ring-[#f5c518]/30"
    >
      <img
        src={portrait}
        alt=""
        className="size-24 rounded-full object-cover ring-2 ring-[#f5c518]/60"
      />
      <span className="mt-3 line-clamp-1 text-base font-semibold text-[#f5c518]">Batman</span>
      <span className="mt-2 rounded-full bg-[#f5c518]/15 px-2.5 py-1 text-xs font-medium text-[#f5c518]/90">
        I skuggorna
      </span>
      <span className="mt-2 text-xs text-[#f5c518]/50">—</span>
    </button>
  );
}

/**
 * Overlayen. Stänger sig själv efter en stund, men går också att trycka bort —
 * ingen ska behöva vänta ut ett skämt för att kunna stämpla in.
 */
export function BatSignalOverlay({ onDone }: { onDone: () => void }) {
  useEffect(() => {
    playBatSting();
    const id = setTimeout(onDone, 3400);
    return () => clearTimeout(id);
  }, [onDone]);

  return (
    <div
      onClick={onDone}
      role="presentation"
      className="bat-overlay fixed inset-0 z-[60] flex flex-col items-center justify-center overflow-hidden bg-[#0a0908]"
    >
      {/*
       * Strålarna ligger inuti den här behållaren och inte direkt i overlayen,
       * så att de utgår från signalens mitt. Låg de i overlayen skulle de
       * centreras mot fönstret, medan signalen sitter en bit ovanför mitten
       * eftersom rubriken under också tar plats — strålarna strålade då ut
       * från en punkt nedanför fladdermusen.
       */}
      <div className="relative flex items-center justify-center">
        <div className="bat-rays pointer-events-none absolute size-[220vmax] opacity-25" />
        <div className="bat-glow pointer-events-none absolute size-[80vmin] rounded-full" />

        <div className="bat-swoop relative">
          <img
            src={signal}
            alt=""
            className="w-[44vmin] drop-shadow-[0_0_6vmin_rgba(245,197,24,0.45)]"
          />
        </div>
      </div>

      <p className="bat-title relative mt-[6vmin] text-center text-[9vmin] leading-none font-black tracking-[0.06em] text-[#f5c518] uppercase [text-shadow:0_0_3vmin_rgba(245,197,24,0.55)]">
        Welcome Batman!
      </p>
      <p className="bat-subtitle relative mt-[2.5vmin] text-[2.6vmin] font-semibold tracking-[0.35em] text-[#f5c518]/70 uppercase">
        Ingen stämpling i natt
      </p>
    </div>
  );
}
